/**
 * A paid unlock refused because the person's active Pro already covers the
 * journey (`BILLING_JOURNEY_COVERED_BY_PRO`, JOURNEYS-MULTI-ROUTE-PLAN · X3).
 *
 * The apps send a Pro subscriber to the Pro unlock; this answer reaches them
 * only when their own copy of the subscription was stale. Both read it the
 * same way: say Pro covers the journey and refresh the subscription, so the
 * dialog offers the Pro unlock.
 */
import { apiErrorCode, DOMAIN_ERROR_CODES } from '@tonnie/foundation';

export function isJourneyCoveredByPro(err: unknown): boolean {
  return apiErrorCode(err) === DOMAIN_ERROR_CODES.BILLING_JOURNEY_COVERED_BY_PRO;
}
